export const CHOOSE_TARIFF_MODEL = 'CHOOSE_TARIFF_MODEL';
export const TARIFF_MODEL = 'TARIFF_MODEL';
export const TARIFF_TYPE = 'TARIFF_TYPE';
export const CHANNELS = 'CHANNELS';
export const CHANNELS_LIST = 'CHANNELS_LIST';
export const INCLUDED_PACKAGES = 'INCLUDED_PACKAGES';
export const CHOOSE_FREE_PACKAGE_1 = 'CHOOSE_FREE_PACKAGE_1';
export const CHOOSE_FREE_PACKAGE_2 = 'CHOOSE_FREE_PACKAGE_2';
export const CHOOSE_FREE_PACKAGE_3 = 'CHOOSE_FREE_PACKAGE_3';
export const ADDITIONAL_PACKAGES = 'ADDITIONAL_PACKAGES';
export const CHOSEN_TARIFF_MODEL = 'CHOSEN_TARIFF_MODEL';
export const CHOSEN_FREE_PACKAGES = 'CHOSEN_FREE_PACKAGES';
export const CHOSEN_ADDITIONAL_PACKAGES = 'CHOSEN_ADDITIONAL_PACKAGES';
export const TOTAL_SUBSCRIPTION = 'TOTAL_SUBSCRIPTION';
export const ORDER = 'ORDER';
export const MKD_MONTHLY = 'MKD_MONTHLY';
export const MKD = 'MKD';
export const CHOOSE = 'CHOOSE';
export const CHOSEN = 'CHOSEN';
export const INCLUDED_CHANNELS_IN_PACKAGE_1 = 'INCLUDED_CHANNELS_IN_PACKAGE_1';
export const INCLUDED_CHANNELS_IN_PACKAGE_2 = 'INCLUDED_CHANNELS_IN_PACKAGE_2';
export const CHANGE_TARIFF = 'CHANGE_TARIFF';
export const CHANGE_TARIFF_WARNING = 'CHANGE_TARIFF_WARNING';
export const CHANGE = 'CHANGE';
export const BACK = 'BACK';
export const CHOOSE_CITY = 'CHOOSE_CITY';
export const CHOOSE_MUNICIPALITY = 'CHOOSE_MUNICIPALITY';
export const INCLUDED_REGIONAL_CHANNELS = 'INCLUDED_REGIONAL_CHANNELS';
export const INCLUDED_CHANNELS_IN_TARIFF = 'INCLUDED_CHANNELS_IN_TARIFF';
export const CHOOSE_CITY_MUNICIPALITY_TARIFF = 'CHOOSE_CITY_MUNICIPALITY_TARIFF';
export const CHOOSE_TARIFF = 'CHOOSE_TARIFF';
export const CHOOSE_FREE_PACKAGE_1_NEW = 'CHOOSE_FREE_PACKAGE_1_NEW';
export const CHOOSE_FREE_PACKAGE_2_NEW = 'CHOOSE_FREE_PACKAGE_2_NEW';
export const CHOOSE_FREE_PACKAGE_2_NEW_FREE = 'CHOOSE_FREE_PACKAGE_2_NEW_FREE';
export const CHOOSE_FREE_PACKAGE_3_NEW = 'CHOOSE_FREE_PACKAGE_3_NEW';
export const CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES = 'CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES';
export const CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE = 'CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE';
export const CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM = 'CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM';
export const PRICE_INCLUDE_VAT = 'PRICE_INCLUDE_VAT';
export const DVBT_OFFER_CHANNELS = 'DVBT_OFFER_CHANNELS';
export const TV_CHANNELS = 'TV_CHANNELS';
export const AVAILABLE = 'AVAILABLE';